import React from 'react';
import TimePicker from 'react-time-picker';
import { FormikValues, FormikConfig } from 'formik';

const CustomTimePicker: React.FC<FormikValues> = ({ field, form, ...props }) => {
  const { name, value } = field;
  const { setFieldValue } = form;

  const handleTimeChange = (newTime: any) => {
    setFieldValue(name, newTime);
  };

  return (
    <TimePicker
      {...props}
      name={name}
      value={value}
      onChange={handleTimeChange}
      onBlur={() => form.setFieldTouched(name, true)}
    />
  );
};

export default CustomTimePicker;
